// @flow
import React, { useEffect } from 'react';
import config from '../../../config/config';
import '../../../static/scss/components/widgets/mentionMeWidget.scss';

type Props = {
  situation: string,
  firstName?: string,
  lastName?: string,
  email?: string
};

const MentionMeWidget = ({ situation, firstName, lastName, email }: Props) => {
  useEffect(
    () => {
      if (!__CLIENT__) {
        return;
      }

      const implementation = 'embed';

      if (window.MentionMeFiredTags !== undefined) {
        // Delete mention me's tracking of what might have previously been rendered.
        delete window.MentionMeFiredTags[implementation + situation];
      }

      const baseUrl = config.isProduction
        ? 'tag.mention-me.com'
        : 'tag-demo.mention-me.com';

      const script = document.createElement('script');
      script.src = `https://${baseUrl}/api/v2/referreroffer/mm210f5a98?situation=${situation}&segment=driver&implementation=${implementation}&firstname=${encodeURIComponent(
        firstName
      )}&surname=${encodeURIComponent(lastName)}&email=${encodeURIComponent(
        email
      )}`;

      window.document.body.appendChild(script);
    },
    [situation, firstName, lastName, email]
  );

  return <div id="mmWrapper" />;
};

MentionMeWidget.defaultProps = {
  firstName: '',
  lastName: '',
  email: ''
};

export default MentionMeWidget;
